import React from "react";
import leftPng from "../../../../content/images/left.png";
import dateTimePng from "../../../../content/images/date-time.png";

class Detail extends React.Component {
  constructor(props) {
    super(props);
    this.rowId =
      this.props.match &&
      this.props.match.params &&
      this.props.match.params.rowId;
    this.state = {
      rowData: this.props.history.location.state.rowData,
    };
  }

  render() {
    return (
      <div id="detailSide" /*className="d-none"*/>
        <div className="detail-title">Natuurbescherming in detail</div>
        <div className="clearfix">
          <div className="float-left mt-4">
            <a
              className="back-page-link"
              role="button"
              onClick={() => {
                this.props.history.push("/catalog/nature-protection/");
              }}
            >
              <img src={leftPng} width={9} height={12} /> &nbsp;Terug naar
              Natuurbescherming
            </a>
          </div>
          <div className="float-right mt-0">
            <a
              id="edit-button"
              className="button bewerken"
              onClick={() => {
                this.props.history.push(
                  "/catalog/nature-protection/edit/" + this.rowId,
                  {
                    rowData: this.state.rowData,
                  }
                );
              }}
            >
              Bewerken
            </a>
          </div>
        </div>
        <div className="row clearfix">
          <div className="col-lg-4 text-center">
            <div className="box-detail-active">
              <div className="box-title-1-active">Wetenschappelijke naam</div>
              <div className="box-title-2-active" id="algemeenNaam">
                {this.state.rowData.wetenschappelijkenaam}
              </div>
              <span className="tooltiptext detail" id="algemeenNaam-tooltip">
                {this.state.rowData.wetenschappelijkenaam}
              </span>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Nederlandse naam</div>
              <div className="box-title-2">
                {this.state.rowData.nederlandsenaam}
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Wet</div>
              <div className="box-title-2">{this.state.rowData.wet}</div>
            </div>
          </div>
        </div>

        <div className="row clearfix">
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Overige status</div>
              <div className="box-title-2">{this.state.rowData.ovg}</div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Naam periode</div>
              <div className="box-title-2">
                {this.state.rowData.naamperiode}
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Soort</div>
              <div className="box-title-2">{this.state.rowData.soort}</div>
            </div>
          </div>
        </div>

        <div className="row clearfix">
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Begin periode</div>
              <div className="box-title-2">
                {this.state.rowData.startperiode}
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Einde periode</div>
              <div className="box-title-2" id="algemeenCode">
                {this.state.rowData.eindeperiode}
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Actief</div>
              <label className="switch">
                <input
                  id="beheereenheid_active"
                  type="checkbox"
                  checked={this.state.rowData.actief ? true : false}
                  disabled
                />
                <span className="slider-checkbox round" />
              </label>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Detail;
